export default __webpack_public_path__ + "static/media/ds-dokushin.5234a956.jpg";